"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../src/ontodia/index");
function onPageLoad(callback) {
    document.addEventListener('DOMContentLoaded', function () {
        var container = document.createElement('div');
        container.id = 'root';
        document.body.appendChild(container);
        callback(container);
    });
}
exports.onPageLoad = onPageLoad;
function tryLoadLayoutFromLocalStorage() {
    if (window.location.hash.length > 1) {
        try {
            var key = window.location.hash.substring(1);
            var unparsedLayout = localStorage.getItem(key);
            var entry = unparsedLayout && JSON.parse(unparsedLayout);
            // backward compatibility test. If we encounder old diagram,
            // wrap it into Diagram interface, jsonld - pass through
            if (entry['@context']) {
                return entry;
            }
            else {
                return index_1.convertToSerializedDiagram({ layoutData: entry, linkTypeOptions: [] });
            }
        }
        catch (e) { /* ignore */ }
    }
    return undefined;
}
exports.tryLoadLayoutFromLocalStorage = tryLoadLayoutFromLocalStorage;
function saveLayoutToLocalStorage(diagram) {
    var randomKey = Math.floor((1 + Math.random()) * 0x10000000000)
        .toString(16).substring(1);
    localStorage.setItem(randomKey, JSON.stringify(diagram));
    return randomKey;
}
exports.saveLayoutToLocalStorage = saveLayoutToLocalStorage;
